import { Declaration } from 'store/declarations/declaration';
import { DeclarationExternalEntity } from 'store/declarations/enums/common/declaration-external-entity';
import { DeclarationInternalType } from 'store/declarations/enums/common/declaration-internal-type';

export const getDucr = (declaration: Declaration): string | undefined => {
    const previousDocuments = declaration?.cdsDeclaration?.cdsDeclarationPayload?.goodsShipment?.previousDocument ?? [];
    return previousDocuments.find((doc) => doc.typeCode === 'DCR')?.id;
};

const isCdsExport = (declaration: Declaration) =>
    declaration.declarationExternalEntity === DeclarationExternalEntity.CDS &&
    declaration.declarationInternalType === DeclarationInternalType.EXPORT;

// A mixed list has one column for both: CDS exports are identified by their DUCR, every other
// declaration by its MRN (for a CDS export that has no DUCR yet, the MRN is the fallback).
const getMrnOrDucr = (declaration: Declaration): string | undefined =>
    isCdsExport(declaration) ? getDucr(declaration) ?? declaration.mrn : declaration.mrn;

export default getMrnOrDucr;
